<script>
  import { onDestroy, onMount, tick } from "svelte"
  import AuthMethodSelection from "./AuthMethodSelection.svelte";
  import ConfigureEProtector from "./ConfigureEProtector.svelte";
  import ConfigureOnlineLicense from "./ConfigureOnlineLicense.svelte";
  import DialogBase2 from "../../../../components/dialog/DialogBase2.svelte";
  import { useInvalidateLicenseData } from "../../../../hooks/license/useLicenseData.js";

  export let onClose
  export let currentPage = "authMethodSelection"

  const {invalidateLicenseData} = useInvalidateLicenseData()

  let dialog
  /**
   * @type {"online"|"eProtector"}
   */
  let selectedAuthMethod = "online"

  function handleClickNext() {
    if (currentPage === "authMethodSelection") {
      if (selectedAuthMethod === "eProtector") currentPage = "configureEProtector"
      else currentPage = "configureOnlineLicense"
    }
  }

  async function handleClose() {
    dialog?.close()
    // invalidate the license information so that it will be reloaded
    await invalidateLicenseData()

    onClose()
  }

  onMount(async () => {
    await tick()
    dialog?.showModal()
  })
  onDestroy(() => {
    dialog?.close()
  })
</script>

<DialogBase2 bind:dialog={dialog} onClose={handleClose} width="800px">
  {#if currentPage === "authMethodSelection"}
    <AuthMethodSelection
      bind:selectedAuthMethod={selectedAuthMethod}
      onClickNext={handleClickNext}
      onClickClose={handleClose}
    />
  {/if}
  {#if currentPage === "configureEProtector"}
    <ConfigureEProtector
      onClickClose={handleClose}
    />
  {/if}
  {#if currentPage === "configureOnlineLicense"}
    <ConfigureOnlineLicense
      onClose={handleClose}
    />
  {/if}
</DialogBase2>
